var _path, _path2, _path3, _path4, _path5, _path6, _path7, _circle, _path8, _path9, _path10, _path11, _path12, _circle2, _path13, _path14, _path15, _path16, _path17, _circle3, _path18, _path19, _path20, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _path21, _path22, _path23, _path24;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFinanceTracking(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 276,
    height: 148,
    viewBox: "0 0 276 148",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M114 139C89.6995 139 70 119.301 70 95C70 70.6995 89.6995 51 114 51C138.301 51 158 70.6995 158 95C158 119.301 138.301 139 114 139Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M112 110C85.4903 110 64 88.5097 64 62C64 35.4903 85.4903 14 112 14C138.51 14 160 35.4903 160 62C160 88.5097 138.51 110 112 110Z",
    fill: "white"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M153 148C126.49 148 105 126.51 105 100C105 73.4903 126.49 52 153 52C179.51 52 201 73.4903 201 100C201 126.51 179.51 148 153 148Z",
    fill: "white"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M169 107C144.699 107 125 87.3005 125 63C125 38.6995 144.699 19 169 19C193.301 19 213 38.6995 213 63C213 87.3005 193.301 107 169 107Z",
    fill: "white"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M144 104C115.281 104 92 80.7188 92 52C92 23.2812 115.281 0 144 0C172.719 0 196 23.2812 196 52C196 80.7188 172.719 104 144 104Z",
    fill: "white"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M140 126C111.281 126 88 102.719 88 74C88 45.2812 111.281 22 140 22C168.719 22 192 45.2812 192 74C192 102.719 168.719 126 140 126Z",
    fill: "#55CF7E"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M144 70L112 102",
    stroke: "#24284E",
    strokeWidth: 8,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 24,
    cy: 24,
    r: 24,
    transform: "matrix(-1 0 0 1 168 46)",
    fill: "#55CF7E",
    stroke: "#24284E",
    strokeWidth: 6,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M149 64V64C149 61.7909 147.209 60 145 60H143C140.791 60 139 61.7909 139 64V64.7352C139 66.1403 139.737 67.4423 140.942 68.1652L147.058 71.8348C148.263 72.5577 149 73.8597 149 75.2648V76C149 78.2091 147.209 80 145 80H143C140.791 80 139 78.2091 139 76V76",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M144 60L144 58",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M144 82L144 80",
    stroke: "#24284E",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M206 78C223.673 78 238 63.6731 238 46C238 28.3269 223.673 14 206 14C188.327 14 174 28.3269 174 46C174 63.6731 188.327 78 206 78Z",
    fill: "#55CF7E"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M203.538 43.5381L223.23 63.2304",
    stroke: "#24284E",
    strokeWidth: 4.92308,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 203.538,
    cy: 43.5378,
    r: 14.7692,
    fill: "#55CF7E",
    stroke: "#24284E",
    strokeWidth: 3.69231,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M206.615 39.8444V39.8444C206.615 38.4849 205.513 37.3828 204.153 37.3828H202.922C201.563 37.3828 200.461 38.4849 200.461 39.8444V40.2968C200.461 41.1615 200.915 41.9627 201.656 42.4076L205.42 44.6658C206.161 45.1106 206.615 45.9119 206.615 46.7765V47.229C206.615 48.5884 205.513 49.6905 204.153 49.6905H202.922C201.563 49.6905 200.461 48.5884 200.461 47.229V47.229",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M203.538 37.3831L203.538 36.1523",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M203.538 50.9212L203.538 49.6904",
    stroke: "#24284E",
    strokeWidth: 2.46154,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M77 112C61.536 112 49 99.464 49 84C49 68.536 61.536 56 77 56C92.464 56 105 68.536 105 84C105 99.464 92.464 112 77 112Z",
    fill: "#55CF7E"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1543 81.8457L61.9235 99.0765",
    stroke: "#24284E",
    strokeWidth: 4.30769,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 12.9231,
    cy: 12.9231,
    r: 12.9231,
    transform: "matrix(-1 0 0 1 92.0781 68.9219)",
    fill: "#55CF7E",
    stroke: "#24284E",
    strokeWidth: 3.23077,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M81.8475 78.6128V78.6128C81.8475 77.4233 80.8832 76.459 79.6937 76.459H78.6167C77.4272 76.459 76.4629 77.4233 76.4629 78.6128V79.0087C76.4629 79.7653 76.8598 80.4664 77.5086 80.8556L80.8018 82.8316C81.4506 83.2208 81.8475 83.9219 81.8475 84.6785V85.0744C81.8475 86.2639 80.8832 87.2282 79.6937 87.2282H78.6167C77.4272 87.2282 76.4629 86.2639 76.4629 85.0744V85.0744",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1553 76.4597L79.1553 75.3828",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M79.1553 88.3054L79.1553 87.2285",
    stroke: "#24284E",
    strokeWidth: 2.15385,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 3,
    cy: 3,
    r: 3,
    transform: "matrix(-1 0 0 1 256 84)",
    fill: "white"
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 2,
    cy: 2,
    r: 2,
    transform: "matrix(-1 0 0 1 4 84)",
    fill: "white"
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 25 145)",
    fill: "white"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 10 1)",
    fill: "white"
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 257 3)",
    fill: "white"
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 1.5,
    cy: 1.5,
    r: 1.5,
    transform: "matrix(-1 0 0 1 276 138)",
    fill: "white"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M221 110L237 114",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M254.5 39.5L267 37",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 40.5L45.5 44.5",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32.5 119L18 123",
    stroke: "white",
    strokeWidth: 4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFinanceTracking);
export default __webpack_public_path__ + "static/media/finance-tracking.f0d3b4a640785e1d98aae9d55c1c9364.svg";
export { ForwardRef as ReactComponent };